import {  Injectable, inject } from "@angular/core";
import { AuthService } from "../01_core/auth/auth.service";
import { HttpClient } from "@angular/common/http";
import { firstValueFrom } from "rxjs";

/** Basic routes for the backend main stack to debug the connection and authentication for the backend domain */
@Injectable({ providedIn: 'root' })
export class DebugService {

  private http = inject(HttpClient);
  private authService = inject(AuthService);
  private authorizedHttp = this.authService.authorize(this.http);

  protected getDebugUrl() {
    return 'https://api.dev.tebiproc.tebis.cloud/debug';
  }

  getTime(){
    return firstValueFrom(this.authorizedHttp.get<string>(`${this.getDebugUrl()}/time`)).then(time => {
      console.log('Current server time:', time);
    });
  }

  getContext(){
    return firstValueFrom(this.authorizedHttp.get<unknown>(`${this.getDebugUrl()}/context`)).then(context => {
      console.log('Current server context:', context);
    });
  }

  getEvent(){
    return firstValueFrom(this.authorizedHttp.get<unknown>(`${this.getDebugUrl()}/event`)).then(event => {
      console.log('Current server events:', event);
    });
  }
}